export default __webpack_public_path__ + "static/media/CardTitleUserSearch.2d48394e.svg";